module.exports = __webpack_public_path__ + "img/22_Bulb.860beb6e.png";